import { Grid } from '@design-systems/canvas-ui'
import Icon from '@design-systems/react-icons'
import { SplitRowProps } from './types'

/**
 * A Simple dual content row for use within a Canvas Grid.Container.
 * The basic layout is
 * --------------------------------------------
 * | icon |  start content  |   end content   |
 * --------------------------------------------
 * The icon + start content width will be equal to the end content width.
 *
 * @param props {@link SplitRowProps}
 * @returns JsxElement
 */
export const SplitRow = ({
    icon,
    start,
    end,
    paddingClass = 'hc8-pv-2x',
}: SplitRowProps) => {
    const rowPadding = paddingClass
    return (
        <>
            <Grid.Item
                className={rowPadding}
                size={{
                    xs: 6,
                }}
            >
                <Grid.Container justify="start" align="center">
                    <Grid.Item className="hc8-pr-none">
                        <Icon
                            svg={icon}
                            size="md"
                            className="split-row__icon"
                            aria-hidden
                        />
                    </Grid.Item>
                    <Grid.Item className="hc8-pv-1x">{start}</Grid.Item>
                </Grid.Container>
            </Grid.Item>
            <Grid.Item
                className={rowPadding}
                size={{
                    xs: 6,
                }}
            >
                {end}
            </Grid.Item>
        </>
    )
}
